import { useState, useEffect } from 'react';
import { useApi, axios, API_BASE_URL } from './useApi';

export interface SocialSettings {
  id: number;
  facebook_url?: string;
  twitter_url?: string;
  instagram_url?: string;
  linkedin_url?: string;
  youtube_url?: string;
  github_url?: string;
  privacy_policy_content?: string;
  terms_content?: string;
  help_content?: string;
  whatsapp_contact?: string;
  contact_email?: string;
  app_download_url?: string;
  youtube_video_url?: string;
  created_at?: string;
  updated_at?: string;
}

export const useSocialSettings = () => {
  const [settings, setSettings] = useState<SocialSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await axios.get(`${API_BASE_URL}/social-settings`);
      
      if (response.data && response.data.data) {
        setSettings(response.data.data);
      } else {
        setError('Nenhuma configuração encontrada');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar configurações');
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings: Partial<SocialSettings>) => {
    try {
      setError(null);
      
      const response = await axios.put(`${API_BASE_URL}/social-settings`, newSettings);
      setSettings(response.data.data);
      return response.data.data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao atualizar configurações');
      throw err;
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return {
    settings,
    loading,
    error,
    refetch: fetchSettings,
    updateSettings,
    // Helpers específicos para WhatsApp
    whatsappContact: settings?.whatsapp_contact || null,
    contactEmail: settings?.contact_email || null,
    isWhatsAppValid: () => {
      if (!settings?.whatsapp_contact) return false;
      const cleaned = settings.whatsapp_contact.replace(/\D/g, '');
      return cleaned.length >= 10 && cleaned.length <= 15;
    },
    formatWhatsAppLink: (message?: string) => {
      if (!settings?.whatsapp_contact) return null;
      
      const cleaned = settings.whatsapp_contact.replace(/\D/g, '');
      const withCountryCode = cleaned.length === 11 ? `55${cleaned}` : cleaned;
      const encodedMessage = encodeURIComponent(message || 'Olá! Gostaria de mais informações.');
      
      return `https://wa.me/${withCountryCode}?text=${encodedMessage}`;
    }
  };
};